import { whatsappLanguages } from "lopermut"

export type AmphoraLogisticsTemplateLocale = (typeof whatsappLanguages)[number]["value"]

/** Locales offered when creating Amphora logistics WhatsApp templates (from `whatsappLanguages` in lopermut; backend copy per code). */
export const AMPHORA_LOGISTICS_TEMPLATE_LOCALES: readonly AmphoraLogisticsTemplateLocale[] =
  whatsappLanguages.map((l) => l.value)
